(() => {
  const prepare = async (picker) => {
    const kind = picker.tagName.toLowerCase();
    await customElements.whenDefined(kind);
    const group = picker.querySelector('[data-buddy-base-option]');
    if (!group) return;
    const radios = [...group.querySelectorAll('input[type="radio"]')];
    const baseRadio = radios.find((input) => input.value.trim().toLowerCase() === 'no');
    const select = group.querySelector('select');
    if (baseRadio) {
      radios.forEach((input) => { input.checked = input === baseRadio; });
    } else if (select) {
      const base = [...select.options].find((option) => option.value.trim().toLowerCase() === 'no');
      if (!base) return;
      select.value = base.value;
    } else return;
    const section = picker.closest('section');
    section?.addEventListener('submit', (event) => {
      const values = [...group.querySelectorAll('input[type="radio"]:checked, select')];
      if (values.some((input) => input.value.trim().toLowerCase() !== 'no')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    (baseRadio || select).dispatchEvent(new Event('change', { bubbles: true }));
  };
  const start = () => document.querySelectorAll('[data-buddy-easify-migration]').forEach(prepare);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
